import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    /* ===================================================================
     * FUENTE GLOBAL DE LA APLICACIÓN
     * Este es el ÚNICO lugar donde se elige la tipografía de todo el sistema.
     * Cambia el valor de --app-font y se propaga a cada componente, porque
     * todo (CSS, styled-components, emotion y el tema de MUI) referencia
     * esta variable con var(--app-font).
     * =================================================================== */
    :root{
        --app-font: 'Metropolis', sans-serif;
        --app-font-weight: 400; /* peso base (normal); los componentes con peso propio lo sobreescriben */
        --color--primary:red;
    }

    *{
        font-family: var(--app-font);
        font-weight: var(--app-font-weight);
    }
    .flex {
        display: flex;
    }

    .noBorder {
        border-color: #FFF;
        border-width: 0;
    }

    .projectGreen {
        background-color: #00984A;
    }

    .projectDarkGray {
        color: #6D6D6D
    }

    .col {
        flex-direction: column;
    }
`;

export default GlobalStyle;
